import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import createLocation from 'utils/createLocation';
import config from 'utils/config';
import { getUrlServiceHref } from 'utils/getUrlServiceHref';
var _ref = config.customContactForm || {},
  url = _ref.url;
export default function useCustomContactLink() {
  var navigate = useNavigate();
  var location = useLocation();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var openModal = function openModal() {
    // Only open our contact form if no custom form URL was defined in the config
    if (!url) {
      var query = {
        modal: 'contact-form'
      };
      navigate(createLocation(location, query));
    }
  };
  return {
    title: t('navbar_contact'),
    url: getUrlServiceHref(url),
    openModal: openModal
  };
}